export default "__VITE_ASSET__RRf_u0xe__"